export default {
  tooltip: {
    balance: "رصيد محفظتي",
    limitSwitch: "سيتم عرض شرح موجز لهذا القسم هنا."
  },
  categoriesMenu: ["الأرخص", "الأغلى"],
  pricesTable: {
    title: "أسعار العملات المشفرة في الوقت الفعلي",
    subtitle: "أسعار العملات",
    noData: "لم يتم العثور على عملات مشفرة",
    latestUpdate: {
      label: "آخر تحديث: ",
      time: "دقائق مضت"
    },
    tableTabs: [
      {
        title: "المفضلة",
        id: 3
      },
      {
        title: "الأصول",
        id: 2
      },
      {
        title: "جميع العملات",
        id: 1
      }
    ],
    tableHeader: [
      {
        text: "الرمز",
        align: "start",
        sortable: true,
        value: "symbol",
        width: 100
      },
      {
        text: "السعر",
        value: "sell_rate_price",
        align: "start",
        sortable: true
      },
      {
        text: "التغييرات",
        value: "daily_change_percent",
        align: "start",
        sortable: true
      }
    ],
    baseCurrencyPrice: "السعر ({iso})",
    searchInputPlaceholder: "بحث"
  },
  orderCard: {
    bitcoin: "بيتكوين"
  },
  orderForm: {
    amountInput: "المبلغ",
    outcome: "المجموع",
    income: "المجموع",
    price: "السعر",
    orderLimit: ["المبلغ", "النسبة"],
    priceReached: "عند الوصول إلى السعر",
    tooltipDesc:
      "في هذا القسم، يمكنك تحديد متى يصل سعر العملة المشفرة المطلوبة إلى السعر المحدد، سيتم تنفيذ عملية الشراء أو البيع لك.",
    orderValidityPeriod: "مدة صلاحية الطلب",
    minutes: "الدقائق",
    hours: "الساعات",
    wage: "الرسوم",
    received: "المستلم",
    sell: "بيع",
    buy: "شراء",
    minAmountRules: "لا يمكنك إدخال أقل من {assetMin} {iso}",
    maxAmountRules: "لا يمكنك إدخال أكثر من {assetMax} {iso}",
    minPriceRules: "لا يمكنك إدخال أقل من {baseMin} {iso}",
    maxPriceRules: "لا يمكنك إدخال أكثر من {baseMax} {iso}",
    minOrderRules: "لا يمكنك تحديد سعر أقل من {minMask} {iso}",
    maxOrderRules: "لا يمكنك تحديد سعر أكثر من {maxMask} {iso}",
    minOrderPercentRules: "الحد الأدنى للمبلغ المدخل يمكن أن يكون -%{percent}",
    maxZeroOrderPercentRules: "الحد الأقصى للمبلغ المدخل يمكن أن يكون %0",
    minZeroOrderPercentRules: "الحد الأدنى للمبلغ المدخل يمكن أن يكون %0",
    maxOrderPercentRules: "الحد الأقصى للمبلغ المدخل يمكن أن يكون %{percent}",
    maxMinute: "{maxMinute} دقائق",
    maxHour: "{maxHour} ساعات",
    and: "و",
    timeRules: "لا يمكنك تحديد أكثر من {minuteRule} {andRule} {hourRule}",
    specifyOrderTime: "يرجى تحديد وقت صلاحية طلبك",
    orderTimeItems: [
      {
        value: "0",
        text: "أقل من ساعة"
      },
      {
        value: "3",
        text: "3 ساعات"
      },
      {
        value: "5",
        text: "5 ساعات"
      },
      {
        value: "8",
        text: "8 ساعات"
      }
    ]
  },
  tradingView: {
    title: "مخطط أسعار العملات المشفرة العالمي",
    description:
      "هذا المخطط لا يعتمد على أسعار Excoino وهو فقط لعرض اتجاهات أسعار العملات المشفرة العالمية.",
    filters: [
      {
        title: "ساعيًا",
        value: "hourly",
        tabIndex: 0
      },
      {
        title: "يوميًا",
        value: "daily",
        tabIndex: 0
      },
      {
        title: "أسبوعيًا",
        value: "weekly",
        tabIndex: 1
      },
      {
        title: "شهريًا",
        value: "monthly",
        tabIndex: 2
      }
    ]
  },
  orderList: {
    viewAllOrders: "عرض جميع الطلبات",
    tabs: [
      {
        faTitle: "جميع الطلبات",
        enTitle: ""
      },
      {
        faTitle: "الطلبات المفتوحة",
        enTitle: "PROCESSING"
      },
      {
        faTitle: "مكتمل",
        enTitle: "DONE"
      },
      {
        faTitle: "منتهية الصلاحية",
        enTitle: "EXPIRED"
      },
      {
        faTitle: "ملغاة",
        enTitle: "CANCELED"
      },
      {
        faTitle: "مرفوضة",
        enTitle: "FAILED"
      }
    ],
    dataTable: {
      typeOfOrder: {
        buy: "شراء",
        sell: "بيع"
      },
      cancelOrder: "إلغاء",
      noData: "ليس لديك أي طلبات مسجلة."
    },
    dataTableHeader: [
      {
        text: "معرف الطلب",
        align: "right",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "النوع",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "اسم العملة",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "المبلغ",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "العملة الأساسية",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "السعر",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "المجموع",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "المستلم الصافي",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "تاريخ الانتهاء",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "الحالة",
        align: "right",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "وقت التسجيل",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      },
      {
        text: "الإجراءات",
        align: "center",
        sortable: false,
        value: "actions",
        width: 100
      }
    ],
    dataTableHeaderWithoutOperation: [
      {
        text: "معرف الطلب",
        align: "right",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "النوع",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "اسم العملة",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "المبلغ",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "العملة الأساسية",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "السعر",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "المجموع",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "المستلم الصافي",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "تاريخ الانتهاء",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "الحالة",
        align: "right",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "وقت التسجيل",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      }
    ],
    modal: {
      ordersHistory: "تاريخ الطلبات"
    }
  },
  orderInvoiceCard: {
    title: "تأكيد الطلب",
    currencyType: "نوع العملة",
    currencyBase: "العملة الأساسية",
    currencyAmount: "المبلغ",
    currencyPrice: "السعر",
    currencyTotalAmount: "المجموع",
    orderExpiredTime: {
      title: "مدة صلاحية الطلب",
      hour: "ساعة",
      minute: "دقيقة"
    },
    currencyFee: "الرسوم",
    currencyPureAmount: "المستلم الصافي",
    buyOrder: "تأكيد الطلب والشراء",
    sellOrder: "تأكيد الطلب والبيع"
  },
  orderNotificationCard: {
    title: "رصيد غير كافٍ",
    description: "رصيد محفظتك غير كافٍ. يرجى زيادة رصيدك ووضع الطلب مرة أخرى.",
    cancelBtn: "إلغاء",
    confirmBtn: "زيادة الرصيد"
  },
  exchangeAutoComplete: {
    inputPlaceholder: "ابحث عن اسم العملة أو الرمز...",
    noResults: "لم يتم العثور على نتائج.",
    noData: "لم يتم العثور على نتائج."
  },
  numberInput: {
    allAssetsButton: "الكل"
  }
};
